import Vue from 'vue';
import Router from 'vue-router';
import DefaultLayout from './layouts/Default.vue';

import Home from './views/Home.vue';
import MyCourses from './views/MyCourses.vue';
import MyAssessments from './views/MyAssessments.vue';
import WillMyCreditsTransfer from './views/WillMyCreditsTransfer.vue';
import RequestMoreInformation from './views/RequestMoreInformation.vue';

Vue.use(Router);

export default new Router({
	routes: [
	{
		path: '/',
		name: '',
		component: DefaultLayout,
		children: [
			{
				path: '',
				name: 'home',
				component: Home,
			},
		],
	},
	{
		path: '/learning',
		name: 'learning',
		component: DefaultLayout,
		children: [
			{
				path: '/learning/my-courses',
				name: 'my-courses',
				component: MyCourses,
			},
			{
				path: '/learning/my-assessments',
				name: 'my-assessments',
				component: MyAssessments,
			},
		],
	}, {
		path: '/transfer',
		name: 'transfer',
		component: DefaultLayout,
		children: [
			{
				path: '/transfer/will-my-credits-transfer',
				name: 'will-my-credits-transfer',
				component: WillMyCreditsTransfer,
			},
			{
				path: '/transfer/request-',
				name: 'request-more-info',
				component: RequestMoreInformation,
			},
		],
	}],
});
